export const getSectionId = (pageId, sectionName) =>
  `${pageId}-${sectionName}-section-locator`;
